import fetchJSON from '../fetchJSON'
// import { xssSanitize as sanitize } from '@bt-react/libs/sanitize'
import { PageState } from '../getPageState'
import validateTopics, { ValidateTopics } from '../validateTopics/validateTopics'
import getPageState from '../getPageState'
import { INVALID_CHANNEL_ID, INVALID_COMMUNICATION_ID } from '../constants'
import convertDuration from '../convertDuration'

// Ensure nothing returned from this is undefined. It MUST be serialisable JSON.

export type Status = 'upcoming' | 'live' | 'processing' | 'recorded'

export type SyndicationChannel = {
  channel: {
    id: number
  }
}

export interface Syndication {
  syndicationIn?: SyndicationChannel
  syndicationOuts?: SyndicationChannel[]
}

export interface WebcastResponse {
  id: number,
  channel: {
    id: number
  },
  description?: string
  duration?: number
  end?: string
  entryTime?: string
  isGigCancelled: boolean
  keywords?: string
  presenter?: string
  previewImg?: string
  start?: string
  status?: Status
  timeZone?: string
  title?: string
  topics?: ValidateTopics[]
  url?: string
  pageState: PageState,
  visibility: string,
  syndication: null | Syndication,
  rating?: number,
  ratingCount?: number
}

export const defaultState: WebcastResponse = {
  id: 0,
  channel: {
    id: 0
  },
  description: '',
  duration: 0,
  end: '',
  entryTime: '',
  isGigCancelled: false,
  keywords: '',
  presenter: '',
  previewImg: '',
  start: '',
  status: 'upcoming',
  timeZone: 'Europe/London',
  title: '',
  topics: [],
  url: '',
  pageState: 'scheduled',
  visibility: 'public',
  syndication: null,
  rating: 0,
  ratingCount: 0
}

export function formatWebcastResponse(response, isGigCancelled = false): WebcastResponse {

  let previewImg: string | null = null

  for (const link of response?.links ?? []) {

    if (previewImg) continue
    if (link.title === 'preview') previewImg = link.href

  }

  const url = response?.url ?? defaultState.url

  const {
    start = defaultState.start,
    duration = defaultState.duration,
    keywords = defaultState.keywords,
    entryTime = defaultState.entryTime,
    end = defaultState.end,
    status = defaultState.status,
    timeZone = defaultState.timeZone,
    visibility = defaultState.visibility,
    syndication = defaultState.syndication,
    rating = defaultState.rating,
    ratingCount = defaultState.ratingCount
  } = response ?? {}

  const pageState = getPageState(start, entryTime, status)

  return {
    id: response?.id ?? defaultState.id,
    channel: {
      id: response?.channel?.id ?? defaultState.channel.id
    },
    title: response?.title ?? defaultState.title,
    description: response?.description ?? defaultState.description,
    presenter: response?.presenter ?? defaultState.presenter,
    // title: sanitize(response?.title ?? defaultState.title),
    // description: sanitize(response?.description ?? defaultState.description),
    // presenter: sanitize(response?.presenter ?? defaultState.presenter),
    duration,
    keywords,
    start,
    entryTime,
    end,
    status,
    timeZone,
    url,
    isGigCancelled,
    previewImg,
    topics: [],
    pageState,
    visibility,
    syndication,
    rating,
    ratingCount
  }

}

const isInvalidData = (data: any) => {

  const code = data?.code

  if (

    (code === INVALID_CHANNEL_ID) || (code === INVALID_COMMUNICATION_ID)

  ) {

    return true

  }

  return false

}

async function fetchWebcast(channelId = '', webcastId = '', hostUrl = ''): Promise<WebcastResponse> {

  if (!channelId || !webcastId) return formatWebcastResponse({}, true)

  let isGigCancelled = false

  const { data, status } = await fetchJSON('fetchWebcast', `${hostUrl || process.env.HOST}/service/communication/v1/channel/${channelId}/communication/${webcastId}/public`)

  if (status === 404 || isInvalidData(data)) {

    isGigCancelled = true

  }

  const webcastData = formatWebcastResponse(data, isGigCancelled)
  webcastData.topics = await validateTopics(hostUrl, webcastData?.keywords)
  webcastData.duration = convertDuration(webcastData.duration)

  return webcastData

}

export default fetchWebcast
